import AuthorizationHelper from '@auth/services/authorization.helper';
import ModulesHelper from '@core/services/modules.helper';

export const postmetaRoutes = [
  {
    path: 'post-categories',
    name: 'admin-post-categories',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.post_categories],
      module: ModulesHelper.CMS_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-post-categories" */ '@cms/pages/post-categories/post-categories.vue'
      ),
  },
];

export const postsRoutes = [
  {
    path: 'posts',
    name: 'admin-posts',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.posts],
      module: ModulesHelper.CMS_MODULE_NAME,
    },
    component: () => import(/* webpackChunkName: "admin-posts" */ '@cms/pages/posts/posts.vue'),
  },
  {
    path: 'post-pages',
    name: 'admin-post-pages',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.posts],
      module: ModulesHelper.CMS_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-posts" */ '@cms/pages/post-pages/post-pages.vue'),
  },
  {
    path: 'post-online-training',
    name: 'admin-online-training',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.posts],
      module: ModulesHelper.CMS_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-posts" */ '@cms/pages/post-online-training/post-online-training.vue'
      ),
  },
  {
    path: 'menu-entries',
    name: 'admin-menu-entries',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.menu_entries],
      module: ModulesHelper.CMS_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-menu-items" */ '@cms/pages/menu-entries/menu-entries.vue'),
  },
];

export const widgetsRoutes = [
  {
    path: 'widgets',
    name: 'admin-widgets',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.widgets],
      module: ModulesHelper.CMS_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-widgets" */ '@cms/pages/widgets/widgets.vue'),
  },
];

export const publicPostsRoutes = [
  {
    path: 'post/:alias',
    name: 'public-post-details',
    meta: {
      layout: 'bpc-public',
      publicRoute: true,
      entity: 'post',
    },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "public-post-details" */ '@cms/pages/singles/post/post-single.vue'
      ),
  },
];
